// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS POUR LA PAGE LOGIN */
.divGlobal {
    width:100%; 
    height: 100vh; 
    background-color:#FFFF;
    /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.1); */
    margin: 0;
}

.colGlobal {
    padding:5%;
    height: 92%;
    margin: 0;
    border-radius:0.5rem ;
}

/* CSS POUR LE SPIN LOADING */
.spinLoading .ant-spin-dot-item {
  background-color: #43CE0C !important;
}

.spinLoading .ant-spin-text {
  color: #43CE0C;
}

.ant-form-item-explain-error {
  text-align: left;
  float: left;
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/auth.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,4CAA4C;IAC5C,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,qBAAqB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* CSS POUR LA PAGE LOGIN */\r\n.divGlobal {\r\n    width:100%; \r\n    height: 100vh; \r\n    background-color:#FFFF;\r\n    /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.1); */\r\n    margin: 0;\r\n}\r\n\r\n.colGlobal {\r\n    padding:5%;\r\n    height: 92%;\r\n    margin: 0;\r\n    border-radius:0.5rem ;\r\n}\r\n\r\n/* CSS POUR LE SPIN LOADING */\r\n.spinLoading .ant-spin-dot-item {\r\n  background-color: #43CE0C !important;\r\n}\r\n\r\n.spinLoading .ant-spin-text {\r\n  color: #43CE0C;\r\n}\r\n\r\n.ant-form-item-explain-error {\r\n  text-align: left;\r\n  float: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
